import React, { useState } from "react";
import FormControl from "react-bootstrap/FormControl";
import FormCheck from 'react-bootstrap/FormCheck';
import { addOrRemoveCounty } from "../utils/commonFunctions";

export const CustomMenu = React.forwardRef(({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
  const [value, setValue] = useState('');

  return (
    <div
      ref={ref}
      style={{ ...style, maxHeight: '300px', overflow: 'scroll' }}
      className={className}
      aria-labelledby={labeledBy}
    >
      <FormControl
        autoFocus
        className="mx-3 my-2 w-auto"
        placeholder="Type to filter..."
        onChange={e => setValue(e.target.value)}
        value={value}
      />
      <ul className="list-unstyled">
        {React.Children.toArray(children).filter(
          child =>
            !value ||
            child.props.children
              .join('')
              .toLowerCase()
              .includes(value.toLowerCase())
        )}
      </ul>
    </div>
  );
});


export const CustomMenuCounties = React.forwardRef(
  (
    {
      children,
      style,
      className,
      'aria-labelledby': labeledBy,
      selectedCounties,
      setSelectedCounties,
    },
    ref
  ) => {
    const [value, setValue] = useState('');
    const checkedCounties = [...selectedCounties];
    const filteredCounties = [];

    return (
      <div
        ref={ref}
        style={{ ...style, maxHeight: '300px', overflow: 'scroll' }}
        className={className}
        aria-labelledby={labeledBy}
      >
        <FormControl
          autoFocus
          className="mx-3 my-2 w-auto"
          placeholder="Type to filter..."
          onChange={(e) => setValue(e.target.value)}
          value={value}
        />

        {React.Children.toArray(children)
          .filter((child) => {
            const county = child.props.children.code + ' - ' + child.props.children.name;
            return !value || county.toLowerCase().includes(value.toLowerCase());
          })
          .forEach((countyObject) => {
            const county = countyObject.props.children;
            filteredCounties.push(
              <FormCheck
                key={county.code}
                className="mx-3 my-2 w-auto"
                type="checkbox"
                checked={checkedCounties.indexOf(county.code) > -1}
                label={county.code + ' - ' + county.name}
                onChange={(e) =>
                  addOrRemoveCounty(checkedCounties, county.code, setSelectedCounties)
                }
              />
            );
          })}
        <div>{filteredCounties}</div>
      </div>
    );
  }
);
